export default {"src":"/_next/static/media/train_24.8c1081c2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};